import { ApplicationStart } from './ApplicationStart.class';
import { ApplicationStep1, HouseholdFormData, ReasonFormData } from './ApplicationStep1.class';
import { ApplicationStep2 } from './ApplicationStep2.class';
import { ApplicationStep3, HDBSolicitor, LegalRepresentation, PrivateSolicitor, TenancyInCommon } from './ApplicationStep3.class';
import { ApplicationStep4 } from './ApplicationStep4.class';
import { ApplicationStep5 } from './ApplicationStep5.class';
import { Owner } from '../polymer/Owner.model';
import { StructureStatusEnum } from '../enum/structure-status.enum';
import { ChangeOwnershipReasonCode } from '../../utils/code-converter';
import { Occupier } from '../polymer/Occupier.model';
import { CooSubmission } from './CooSubmission.class';
import { HoldingTypeEnum } from '../enum/holding-type.enum';
import { FileContent, FileItem } from '../polymer/Document.model';
import { Helpers } from '../../utils/helper';
import { Properties, PropertyFinancingInfo, SMSInfo } from '../polymer/Properties.model';
import { OwnerTypeEnum } from '../enum/owner-type.enum';
import { SolicitorTypeEnum } from '../enum/solicitor-type.enum';
import { get } from 'lodash';
import { LoanTypeEnum } from '../enum/loan-type.enum';
import data from "../../../src/utils/shared/dummy.json";
import { AdministrativeRole, MyInfo, MyInfoWithDOD } from '../polymer/MyInfo.model';
import { convertStructureStatusToRole } from '../../utils/form-helper';
import { PolymerCrypto } from '../../utils/encryptor';

export const dummyDraftMapping = {
  "hdb_ref": "12345678901",
  "address": "Block 772, Bedok Reservoir View, #16-142, Singapore 470772",
  
  //Step Start
  "flat_type": "03", //NEW ADDED
  "holding_type": "JT", //NEW ADDED - Curernt holding type,  NOTE: Not proposed holding type

  //Step 1
  "change_ownership_reason": "COR6",
  "has_private_property": true,
  "has_dispose_property": false,
  
  "change_in_marital_status": {},
  "change_in_financial_circumstances": {},
  "demise_of_current_owner": {},
  "renunciation": {},
  "moving_out": {
    "situation": "moving_out_due_to_marriage",
    "date_of_marriage": "2023-08-15"
  },
  "owners": [
    {
        "structure_status": "HSS2",
        "children_care_and_control": "",
        "relationship_with_owner": "",
        "is_related": true,
        "structure_order": "L1",
        "uinfin": "S0013339F",
        "name": "Alicia Lee Bee Wah",
        "residential_status": "C",
        "spr_obtained_date": "",
        "dob": "1956-08-13",
        "mobile_no": "99999999",
        "marital_status": "1",
        "email": "zhihwa97@hotmail.com",
        "is_applicant": true
    },
    {
        "structure_status": "HSS3",
        "children_care_and_control": "",
        "relationship_with_owner": "",
        "is_related": false,
        "structure_order": "L2",
        "uinfin": "M4241468Q",
        "name": "FAN ZHI HWA",
        "residential_status": "C",
        "spr_obtained_date": "",
        "dob": "1988-05-09",
        "mobile_no": "",
        "marital_status": "1",
        "email": "",
        "is_applicant": true
    },
    {
        "structure_status": "HSS2",
        "children_care_and_control": "",
        "relationship_with_owner": "",
        "structure_order": "",
        "uinfin": "S9174729D",
        "name": "Jason Tan",
        "residential_status": "",
        "spr_obtained_date": "",
        "dob": "1990-05-05",
        "mobile_no": "",
        "marital_status": "",
        "email": "",
        "is_applicant": false
    }
  ],
  "occupiers": [
      {
          "structure_status": "HSS3",
          "relationship_with_owner": "FA",
          "uinfin": "S0013339F",
          "name": "AH GUANG",
          "residential_status": "C",
          "spr_obtained_date": "",
          "dob": "1976-06-28",
          "mobile_no": "",
          "marital_status": "1",
          "email": ""
      }
  ],

  //Step 2
  "financing_info": {
    "current_loan_type": "H",
    "current_loan_amount": 456.23,
    "current_loan_date": "2021-03-20",
    "new_loan_type": "H"
  },

  //Step 3
  "confirm_attend_completion_person": "Yes",
  "conveyancing": {
    "holding_type": "SO",
    "valuation": "",
    "tenancy_in_common": [],
    "legal_representation": [
      {
        "solicitor_type": "hdb_solicitor",
        "owner_type": "current",
        "hdb_legal_term_condition": true,
        "conveyancing_same_solicitor": true,
        "solicitor": {
          "uen_of_law_firm": "",
          "name_of_law_firm": "",
          "email_of_solicitor": ""
        },
        "conveyancing_solicitor": {
          "uen_of_law_firm": "",
          "name_of_law_firm": "",
          "email_of_solicitor": ""
        },
      },
      {
        "solicitor_type": "private_solicitor",
        "owner_type": "proposed",
        "hdb_legal_term_condition": false,
        "conveyancing_same_solicitor": true,
        "solicitor": {
          "uen_of_law_firm": "",
          "name_of_law_firm": "",
          "email_of_solicitor": ""
        },
        "conveyancing_solicitor": {
          "uen_of_law_firm": "1234",
          "name_of_law_firm": "example",
          "email_of_solicitor": "example@example.com"
        },
      }
    ]
  },

  //Step 4
  "documents": [
    {
        id: 131,
        code: "DC09",
        file_name: "Document 1",
        label: "", //Will use as Unique identifier because code field will be duplicated when multiple owners required the same document.
        document_type: "pdf",
        required_option_checked: true,
    },
    {
        id: 132,
        code: "DC06",
        file_name: "Document 2",
        document_type: "pdf",
        label: "", //Will use as Unique identifier because code field will be duplicated when multiple owners required the same document.
        required_option_checked: true,
    }
  ]
 
}
export const dummyDraftMappingWithStageBData = data.dummyDraftMappingWithStageBData;
export const jasonAliciaDummyDraft = data.jasonAliciaDummyDraft;

const getValueByBoolean = (bool: boolean | undefined) => {
    if(bool !== undefined){
      return bool === true ? "yes" : "no";
    }else{
      return undefined;
    }
}

export class MapDraft extends CooSubmission {
  main_applicant_uinfin: string;
  submit_date: string
  polymer_stage: string;
  polymer_status: string;
  
  constructor(initial?: any) {
    super(initial);
    this.main_applicant_uinfin = get(initial, "main_applicant_uinfin", "");
    this.submit_date = get(initial, "submit_date", "");
    this.polymer_stage = get(initial, "polymer_stage", "A1");
    
    // Safely decrypt polymer_status
    const encryptedStatus = get(initial, "polymer_status", "");
    let decryptedStatus = "";
    try {
      if (encryptedStatus) {
        decryptedStatus = PolymerCrypto.decryption(encryptedStatus);
      }
    } catch (err) {
      console.error("Failed to decrypt polymer_status", err);
    }
    this.polymer_status = decryptedStatus;
  }

  generateStepStartMapping(){

    const additional_roles_applicant = this.owners?.filter(e=> !(e.structure_status === StructureStatusEnum.incoming || e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing)).map(e=>{
      const role_name = convertStructureStatusToRole(e.structure_status);
      let email = PolymerCrypto.decryption(e?.email);
      let mobile_no = PolymerCrypto.decryption(e?.mobile_no);
      let uinfin = PolymerCrypto.decryption(e?.uinfin);

      return new MyInfoWithDOD({...e, role_name, email, uinfin, mobile_no});
    }) 

    const current_owner = this.owners?.filter(e=> (e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing));
    const current_occupier = this.occupiers?.filter(e=> (e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing));

    let financing_info = new PropertyFinancingInfo({ 
      current_loan_amount: this.financing_info.current_loan_amount, 
      current_loan_date: this.financing_info.current_loan_date, 
      current_loan_type: this.financing_info.current_loan_type as LoanTypeEnum
    });

    //default will set tru when get from map, because they can only saveDraft in A1 onwards. Mean this should be true. So no need to retrieve from API
    let checkbox_values = {
      checked_coo:true,
      checked_tnc:true
    }
    
    let selected_hdb_property = new Properties({
      hdb_ref:this.hdb_ref,
      flat_type:this.flat_type,
      holding_type:this.holding_type,
      address: this.address,
      main_applicant_uinfin: PolymerCrypto.decryption(this.main_applicant_uinfin),
      owners: current_owner,
      occupiers: current_occupier,
      additional_roles: additional_roles_applicant?.map(additionalRole => new AdministrativeRole(additionalRole)),
      ...financing_info
    });

    let submit_date_field = { submit_date: this.submit_date }
    return new ApplicationStart({...this, ...checkbox_values, selected_hdb_property, ...submit_date_field});
  }

  generateWithSmsStepStartMapping(smsInfo: SMSInfo, property?: Properties, hasOutstandingLoan?: boolean){
    let additional_roles_applicant: MyInfoWithDOD[] = [];
    if(!property){
      additional_roles_applicant = this.owners?.filter(e=> !(e.structure_status === StructureStatusEnum.incoming || e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing)).map(e=>{
        const role_name = convertStructureStatusToRole(e.structure_status);
        let email = PolymerCrypto.decryption(e?.email);
        let mobile_no = PolymerCrypto.decryption(e?.mobile_no);
        let uinfin = PolymerCrypto.decryption(e?.uinfin);

        return new MyInfoWithDOD({...e, role_name, email, uinfin, mobile_no});
      }) ?? [];
    }else{
      additional_roles_applicant = property.additional_roles.map(e => new MyInfoWithDOD({...e, uinfin: PolymerCrypto.decryption(e.uinfin)}));
    }

    const current_owner = this.owners?.filter(e=> (e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing)).map(e=>{
      let email = PolymerCrypto.decryption(e?.email);
      let mobile_no = PolymerCrypto.decryption(e?.mobile_no);
      let uinfin = PolymerCrypto.decryption(e?.uinfin);
      let marital_status = property?.owners?.find(item => PolymerCrypto.decryption(e?.uinfin) === item.uinfin)?.marital_status ?? "";
      let name = property?.owners?.find(item => PolymerCrypto.decryption(e?.uinfin) === item.uinfin)?.name ?? "";
      let role_name = property?.owners?.find(item => PolymerCrypto.decryption(e?.uinfin) === item.uinfin)?.role_name ?? "";

      return new MyInfoWithDOD({...e, email, uinfin, mobile_no, marital_status, name, role_name});

    });
    const current_owner_uinfin = current_owner?.map(e=> e.uinfin);
    
    
    const current_occupier = this.occupiers?.filter(e=> (e.structure_status === StructureStatusEnum.retaining || e.structure_status === StructureStatusEnum.outgoing) && !current_owner_uinfin?.includes(PolymerCrypto.decryption(e.uinfin))).map(e=>{
      let email = PolymerCrypto.decryption(e?.email);
      let mobile_no = PolymerCrypto.decryption(e?.mobile_no);
      let uinfin = PolymerCrypto.decryption(e?.uinfin);
      let marital_status = property?.occupiers?.find(item => PolymerCrypto.decryption(e?.uinfin) === item.uinfin)?.marital_status ?? "";
      let name = property?.occupiers?.find(item => PolymerCrypto.decryption(e?.uinfin) === item.uinfin)?.name ?? "";

      return new MyInfo({...e, email, uinfin, mobile_no, marital_status, name});

    });

    let financing_info = new PropertyFinancingInfo({ 
      current_loan_amount: smsInfo.financing_info.current_loan_amount, 
      current_loan_date: smsInfo.financing_info.current_loan_date, 
      current_loan_type: smsInfo.financing_info.current_loan_type,
      sales_type_code: smsInfo.financing_info.sales_type_code,
      num_months_in_arrears_or_advance: smsInfo.financing_info.num_months_in_arrears_or_advance,
      estate_action_code: smsInfo.financing_info.estate_action_code
    });

    //default will set tru when get from map, because they can only saveDraft in A1 onwards. Mean this should be true. So no need to retrieve from API
    let checkbox_values = {
      checked_coo:true,
      checked_tnc:true
    }
    
    let selected_hdb_property = new Properties({
      hdb_ref:this.hdb_ref,
      flat_type: this.flat_type ?? smsInfo?.flat_type,
      holding_type: this.holding_type || smsInfo?.holding_type,
      lease_issue_tag: smsInfo?.lease_issue_tag ?? "",
      address: this.address,
      main_applicant_uinfin: PolymerCrypto.decryption(this.main_applicant_uinfin),
      owners: current_owner,
      occupiers: current_occupier,
      additional_roles: additional_roles_applicant.map(additionalRole => new AdministrativeRole(additionalRole)),
      eligibility_scheme_code: smsInfo?.eligibility_scheme_code,
      ...financing_info
    });
    return new ApplicationStart({...this, ...checkbox_values, selected_hdb_property, has_outstanding_loan: hasOutstandingLoan ?? false});
  }

  //GENERATE STEP 1 HOUSEHOLD SLICE VALUE
  generateStep1Mapping(property?: Properties){
    //REASON
    let ReasonObj = ChangeOwnershipReasonCode.find(e=>e.code === this.change_ownership_reason);
    let reason = ReasonObj?.reason_value;
    let change_ownership_reason = ReasonObj?.change_ownership_reason_value;
    const movingOutValues = {...this.moving_out};
    const changeInMaritalStatusValues = {...this.change_in_marital_status};
    const changeInFinancialCircumstancesValues = {...this.change_in_financial_circumstances};
    const demiseValues = {...this.demise_of_current_owner};
    const renunciationValues = {...this.renunciation};

    changeInMaritalStatusValues.have_final_judgement = getValueByBoolean(changeInMaritalStatusValues.have_final_judgement);
    changeInMaritalStatusValues.amount_stated_in_court_order = changeInMaritalStatusValues.consideration_amount_stated ? changeInMaritalStatusValues.consideration_amount_stated.toFixed(2) : "";
    changeInMaritalStatusValues.cpf_refund = changeInMaritalStatusValues.cpf_refund_outgoing_owner;
    changeInMaritalStatusValues.date_of_court_order = changeInMaritalStatusValues.due_date_complete_application;
    changeInMaritalStatusValues.submit_content = changeInMaritalStatusValues.confirm_remove_owner_singpass_login;

    changeInFinancialCircumstancesValues.has_outstanding_loan = changeInFinancialCircumstancesValues.have_outstanding_bank_loan;
    changeInFinancialCircumstancesValues.outstanding_loan_amount = changeInFinancialCircumstancesValues?.bank_loan_amount?.toString() ?? "";
    
    demiseValues.has_administration_items = demiseValues.have_related_document; //BE return have_related_document, so map have_related_document to has_administration_items
    demiseValues.death_date = demiseValues.date_of_dead;
    demiseValues.is_beneficiary_proposed_owners = demiseValues.listed_beneficiaries_is_proposed_owners ? demiseValues.listed_beneficiaries_is_proposed_owners.toString() : "";
    
    let reasonFormData = new ReasonFormData({
      registrar_uinfin: this.outgoing_owner_represented,
      ...movingOutValues,
      ...changeInMaritalStatusValues,
      ...changeInFinancialCircumstancesValues,
      ...demiseValues,
      ...renunciationValues,
      reason,change_ownership_reason});


    const propertyOwners = property?.owners ?? [];

    let owners:Owner[] = [];
    //Current Owners
    this.owners?.filter((e : Owner)=> (e.structure_order === "" || e.structure_status === StructureStatusEnum.outgoing || e.structure_status === StructureStatusEnum.retaining)).forEach(owner_item => {
      /**
       * Remove Additional Role out of current owners
       */
      if((owner_item.structure_status === StructureStatusEnum.retaining || owner_item.structure_status === StructureStatusEnum.incoming || owner_item.structure_status === StructureStatusEnum.outgoing)){
        
        let is_related = (!!owner_item?.is_related) || owner_item?.relationship_with_owner?.length > 0;
        let relationship_with_owner = owner_item.relationship_with_owner ? owner_item.relationship_with_owner : "";
        let email = PolymerCrypto.decryption(owner_item?.email);
        let mobile_no = PolymerCrypto.decryption(owner_item?.mobile_no);
        let uinfin = PolymerCrypto.decryption(owner_item?.uinfin);
        let spouse = PolymerCrypto.decryption(owner_item?.spouse);
        let name = propertyOwners.find(item => item.uinfin === uinfin)?.name ?? owner_item.name ?? "";
        let role_name = propertyOwners.find(item => item.uinfin === uinfin)?.role_name ?? "";
        
        let ownerObj = new Owner({...owner_item, spouse:spouse, relationship_with_owner, is_related, role_name, myinfo: new MyInfo({...owner_item, email, mobile_no, uinfin, name})});
        owners.push(ownerObj);
      }
    });

    //code below reorder owner
    const orderedOwners: Owner[] = [];
    for(const owner of propertyOwners){
        const findOwner = owners.find(item => item.myinfo.uinfin === owner.uinfin);
        if(findOwner){
          orderedOwners.push(findOwner);
        }
    }

    if(orderedOwners.length > 0){
        owners = orderedOwners;
    }

    //Current Occupiers
    const propertyOccupiers = property?.occupiers ?? [];
    let occupiers = this.occupiers?.filter((e : Occupier | any)=> (e.structure_status === StructureStatusEnum.outgoing || e.structure_status === StructureStatusEnum.retaining)).map(occupier_item=>{
      
      let is_related = occupier_item.relationship_with_owner !== "OT"
      let relationship_with_owner = occupier_item.relationship_with_owner === "OT" ? "" : occupier_item.relationship_with_owner;
      let email = PolymerCrypto.decryption(occupier_item?.email);
      let mobile_no = PolymerCrypto.decryption(occupier_item?.mobile_no);
      let uinfin = PolymerCrypto.decryption(occupier_item?.uinfin);
      let spouse = PolymerCrypto.decryption(occupier_item?.spouse);
      let name = propertyOccupiers.find(item => item.uinfin === uinfin)?.name ?? occupier_item.name ?? "";
      let occupierObj = new Occupier({...occupier_item, spouse:spouse, relationship_with_owner, is_related, myinfo: new MyInfo({...occupier_item, email, mobile_no, uinfin, name})});
      return occupierObj;
    });
    

    //HOUSEHOLD
    let incoming_owners = this.owners?.filter(
      (e) => e.structure_order !== "" || e.structure_status === StructureStatusEnum.retaining
    ).map(owner=>{
      
      let is_related = (!!owner?.is_related) || owner?.relationship_with_owner?.length > 0;
      let relationship_with_owner = owner.relationship_with_owner ? owner.relationship_with_owner : "";
      let email = PolymerCrypto.decryption(owner?.email);
      let mobile_no = PolymerCrypto.decryption(owner?.mobile_no);
      let uinfin = PolymerCrypto.decryption(owner?.uinfin);
      let spouse = PolymerCrypto.decryption(owner?.spouse);
      
      let ownerObj = new Owner({...owner, spouse:spouse, is_related, relationship_with_owner, myinfo: new MyInfo({...owner, email, mobile_no, uinfin})});
      return ownerObj;
    });

    incoming_owners?.sort((a, b) => {
      const orderA = a.structure_order || "L0";
      const orderB = b.structure_order || "L0";
      return orderA.localeCompare(orderB);
    });

    let incoming_occupiers = this.occupiers?.filter(e=>(e.structure_status === StructureStatusEnum.incoming) || (e.structure_status === StructureStatusEnum.retaining)).map(occupier=>{
      
      let is_related = occupier.relationship_with_owner !== "OT"
      let relationship_with_owner = occupier.relationship_with_owner === "OT" ? "" : occupier.relationship_with_owner;
      let email = PolymerCrypto.decryption(occupier?.email);
      let mobile_no = PolymerCrypto.decryption(occupier?.mobile_no);
      let uinfin = PolymerCrypto.decryption(occupier?.uinfin);
      let spouse = PolymerCrypto.decryption(occupier?.spouse);
      
      let occupierObj = new Occupier({...occupier, spouse:spouse, relationship_with_owner, is_related, myinfo: new MyInfo({...occupier, email, mobile_no, uinfin})});
      return occupierObj;
    });


    let householdFormData = new HouseholdFormData({check_has_private_property:this.has_private_property, check_has_dispose_property:this.has_dispose_property, incoming_owners,incoming_occupiers, owners, occupiers})
    
    return new ApplicationStep1({household:householdFormData, reason:reasonFormData});
  }


  //GENERATE STEP 2 FINANCING SLICE VALUE
  generateStep2Mapping(){
    return new ApplicationStep2({...this.financing_info});
  }

  generateStep2MappingWithSmsInfo(smsInfo: SMSInfo){
    const {
      current_loan_type,
      current_loan_amount,
      current_loan_date,
      num_months_in_arrears_or_advance,
      sales_type_code,
      estate_action_code,
      has_current_outstanding_loan,
    } = smsInfo.financing_info;

    // Base info from Polymer DB, replace info from SMS if present.
    return new ApplicationStep2({
      ...this.financing_info,
      ...(current_loan_type && { current_loan_type }),
      ...(current_loan_amount && { current_loan_amount }),
      ...(current_loan_date && { current_loan_date }),
      ...(num_months_in_arrears_or_advance && { num_months_in_arrears_or_advance }),
      ...(sales_type_code && { sales_type_code }),
      ...(estate_action_code && { estate_action_code }),
      ...(has_current_outstanding_loan && { has_current_outstanding_loan }),
    });
  }
  
  //GENERATE STEP 3 CONVEYANCING SLICE VALUE
  generateStep3Mapping(){
    
    let tenancy_in_common = this.conveyancing.tenancy_in_common.map(e=>{
      let found_owner = this.owners?.find(owner=>PolymerCrypto.decryption(owner.uinfin) === e.owner_uinfin);
      return new TenancyInCommon({
        shares: e.share_percent.toString(),
        user: new Owner({...found_owner, uinfin: PolymerCrypto.decryption(found_owner.uinfin)})
      })
    });

    let current_conveyancing = this.conveyancing.legal_representation.find(e=>e.owner_type === OwnerTypeEnum.current);
    let proposed_conveyancing = this.conveyancing.legal_representation.find(e=>e.owner_type === OwnerTypeEnum.proposed);
    let outgoing_conveyancing = this.conveyancing.legal_representation.find(e=>e.owner_type === OwnerTypeEnum.outgoing);

    let current_solicitor_type = current_conveyancing?.solicitor_type;
    let proposed_solicitor_type = proposed_conveyancing?.solicitor_type;
    let outgoing_solicitor_type = outgoing_conveyancing?.solicitor_type;

    let current = new LegalRepresentation({
      hdb_solicitor: new HDBSolicitor({
        is_confirm: current_conveyancing?.hdb_legal_term_condition,
        tnc: current_conveyancing?.hdb_legal_term_condition,
        represented_same_solicitor: current_conveyancing?.solicitor_type === SolicitorTypeEnum.hdb_solicitor ? current_conveyancing?.conveyancing_same_solicitor : false
      }),
      private_solicitor: new PrivateSolicitor({
        is_confirm: current_conveyancing?.solicitor.uen_of_law_firm !== "",
        uen: current_conveyancing?.solicitor.uen_of_law_firm,
        name_of_firm: current_conveyancing?.solicitor.name_of_law_firm,
        email_of_solicitor: current_conveyancing?.solicitor.email_of_solicitor,
        represented_same_solicitor: current_conveyancing?.solicitor_type === SolicitorTypeEnum.private_solicitor ? current_conveyancing?.conveyancing_same_solicitor : false,

        block_house_number: current_conveyancing?.solicitor.block_house_number,
        street_name: current_conveyancing?.solicitor.street_name,
        level: current_conveyancing?.solicitor.level,
        unit_number: current_conveyancing?.solicitor.unit_number,
        postal_code: current_conveyancing?.solicitor.postal_code,
        building_name: current_conveyancing?.solicitor.building_name,
        telephone_number: current_conveyancing?.solicitor.telephone_number
      }),
      conveyancing_private_solicitor: new PrivateSolicitor({
        is_confirm: current_conveyancing?.conveyancing_solicitor.uen_of_law_firm !== "",
        uen: current_conveyancing?.conveyancing_solicitor.uen_of_law_firm,
        name_of_firm: current_conveyancing?.conveyancing_solicitor.name_of_law_firm,
        email_of_solicitor: current_conveyancing?.conveyancing_solicitor.email_of_solicitor,
        represented_same_solicitor: false,

        block_house_number: current_conveyancing?.conveyancing_solicitor.block_house_number,
        street_name: current_conveyancing?.conveyancing_solicitor.street_name,
        level: current_conveyancing?.conveyancing_solicitor.level,
        unit_number: current_conveyancing?.conveyancing_solicitor.unit_number,
        postal_code: current_conveyancing?.conveyancing_solicitor.postal_code,
        building_name: current_conveyancing?.conveyancing_solicitor.building_name,
        telephone_number: current_conveyancing?.conveyancing_solicitor.telephone_number
      }),
      is_conveyancing_hdb: current_conveyancing?.solicitor_type === SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor
    });
    let proposed = new LegalRepresentation({
      hdb_solicitor: new HDBSolicitor({
        is_confirm: proposed_conveyancing?.hdb_legal_term_condition,
        tnc: proposed_conveyancing?.hdb_legal_term_condition,
        represented_same_solicitor: proposed_conveyancing?.solicitor_type === SolicitorTypeEnum.hdb_solicitor ? proposed_conveyancing?.conveyancing_same_solicitor : false
      }),
      private_solicitor: new PrivateSolicitor({
        is_confirm: proposed_conveyancing?.solicitor.uen_of_law_firm !== "",
        uen: proposed_conveyancing?.solicitor.uen_of_law_firm,
        name_of_firm: proposed_conveyancing?.solicitor.name_of_law_firm,
        email_of_solicitor: proposed_conveyancing?.solicitor.email_of_solicitor,
        represented_same_solicitor: proposed_conveyancing?.solicitor_type === SolicitorTypeEnum.private_solicitor ? proposed_conveyancing?.conveyancing_same_solicitor : false,
        
        block_house_number: proposed_conveyancing?.solicitor.block_house_number,
        street_name: proposed_conveyancing?.solicitor.street_name,
        level: proposed_conveyancing?.solicitor.level,
        unit_number: proposed_conveyancing?.solicitor.unit_number,
        postal_code: proposed_conveyancing?.solicitor.postal_code,
        building_name: proposed_conveyancing?.solicitor.building_name,
        telephone_number: proposed_conveyancing?.solicitor.telephone_number
      }),
      conveyancing_private_solicitor: new PrivateSolicitor({
        is_confirm: proposed_conveyancing?.conveyancing_solicitor.uen_of_law_firm !== "",
        uen: proposed_conveyancing?.conveyancing_solicitor.uen_of_law_firm,
        name_of_firm: proposed_conveyancing?.conveyancing_solicitor.name_of_law_firm,
        email_of_solicitor: proposed_conveyancing?.conveyancing_solicitor.email_of_solicitor,
        represented_same_solicitor: false,

        block_house_number: proposed_conveyancing?.conveyancing_solicitor.block_house_number,
        street_name: proposed_conveyancing?.conveyancing_solicitor.street_name,
        level: proposed_conveyancing?.conveyancing_solicitor.level,
        unit_number: proposed_conveyancing?.conveyancing_solicitor.unit_number,
        postal_code: proposed_conveyancing?.conveyancing_solicitor.postal_code,
        building_name: proposed_conveyancing?.conveyancing_solicitor.building_name,
        telephone_number: proposed_conveyancing?.conveyancing_solicitor.telephone_number
      }),
      is_conveyancing_hdb: proposed_conveyancing?.solicitor_type === SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor
    });

    let outgoing = new LegalRepresentation({
      hdb_solicitor: new HDBSolicitor({
        is_confirm: true,
        tnc: outgoing_conveyancing?.hdb_legal_term_condition,
        represented_same_solicitor: outgoing_conveyancing?.solicitor_type === SolicitorTypeEnum.hdb_solicitor ? outgoing_conveyancing?.conveyancing_same_solicitor : false
      }),
      private_solicitor: new PrivateSolicitor(),//Hardcoded as loan solicitor will not be selected by outgoing
      conveyancing_private_solicitor: new PrivateSolicitor({
        is_confirm: outgoing_conveyancing?.conveyancing_solicitor.uen_of_law_firm !== "",
        uen: outgoing_conveyancing?.conveyancing_solicitor.uen_of_law_firm,
        name_of_firm: outgoing_conveyancing?.conveyancing_solicitor.name_of_law_firm,
        email_of_solicitor: outgoing_conveyancing?.conveyancing_solicitor.email_of_solicitor,
        represented_same_solicitor: outgoing_conveyancing?.solicitor_type === SolicitorTypeEnum.private_solicitor ? outgoing_conveyancing?.conveyancing_same_solicitor : false,

        block_house_number: outgoing_conveyancing?.conveyancing_solicitor.block_house_number,
        street_name: outgoing_conveyancing?.conveyancing_solicitor.street_name,
        level: outgoing_conveyancing?.conveyancing_solicitor.level,
        unit_number: outgoing_conveyancing?.conveyancing_solicitor.unit_number,
        postal_code: outgoing_conveyancing?.conveyancing_solicitor.postal_code,
        building_name: outgoing_conveyancing?.conveyancing_solicitor.building_name,
        telephone_number: outgoing_conveyancing?.conveyancing_solicitor.telephone_number
      }),
    });

    let is_holding_type_confirm = false; //Default to true because its from draft
    if(this.conveyancing.holding_type === HoldingTypeEnum.tenancy_in_common){
      is_holding_type_confirm = tenancy_in_common.every(e=> {
        return e.shares !== '0';
      });
    }
    else if(this.conveyancing.holding_type){
      is_holding_type_confirm = true; 
    }
    let attendHdbInPerson: boolean | undefined = undefined;
    switch(this.confirm_attend_completion_person){
      case "Yes": 
        attendHdbInPerson = true;
        break;
      case "No":
        attendHdbInPerson = false;
        break;
      default:
        attendHdbInPerson = undefined;
        break;
    }
    
    return new ApplicationStep3({
      valuation: this.conveyancing.valuation,
      holding_type: this.conveyancing.holding_type as HoldingTypeEnum,
      is_holding_type_confirm: is_holding_type_confirm, 
      tenancy_in_common: tenancy_in_common,
      attend_hdb_in_person: attendHdbInPerson,
      proposed_same_solicitor: this.conveyancing.proposed_same_solicitor,
      estimated_market_value: this.conveyancing.estimated_market_value ? Number(this.conveyancing.estimated_market_value).toFixed(2) : "",
      current_solicitor_type: current_solicitor_type === SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor ? SolicitorTypeEnum.private_solicitor : current_solicitor_type,
      proposed_solicitor_type: proposed_solicitor_type === SolicitorTypeEnum.private_mortgage_hdb_conveyancing_solicitor ? SolicitorTypeEnum.private_solicitor : proposed_solicitor_type,
      outgoing_solicitor_type: outgoing_solicitor_type,
      current: current,
      proposed: proposed,
      outgoing: outgoing,
      outgoing_different_solicitor: outgoing_solicitor_type && outgoing_solicitor_type.length > 0
    }) 
  }

  generateStep4Mapping(){
    // Filter out specific document codes
    const includedDocumentCodes = ['DC01', 'DC02', 'DC03', 'DC04', 'DC05', 'DC06', 'DC07', 'DC08', 'DC09', 'DC10', 'DC11', 'DC12', 'DC13', 'DC14', 'DC15', 'DC16', 'DC17', 'DC18', 'DC19', 'DC20', 'DC21', 'DC22', 'DC23', 'DC24', 'DC25', 'DC26', 'DC27', 'DC28', 'DC29', 'DC30'];
    let file_items = this.documents.filter(e=>e.key && e.code && includedDocumentCodes.includes(e.code)).map((e)=>{
      return new FileItem({uinfin: e.uinfin ? PolymerCrypto.decryption(e.uinfin) : "", file_id: e.uuid, key: e.key, code: e.code, label:e.label, file_content: new FileContent({id:Helpers.generateAlphaNumericID(), file_name:e.file_name, document_type:e.document_type, size: e.file_size ?? 0})})
    })
    const excepted_documents = this.excepted_documents;
    return new ApplicationStep4({file_items, excepted_documents});
  }
  
  
  generateStep5Mapping(){
    return new ApplicationStep5(this);
  }

}
